var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.316 11.494a.297.297 0 01-.213-.088L1.087 6.391a.298.298 0 010-.425.298.298 0 01.425 0l4.804 4.803L16.488.594a.298.298 0 01.425 0 .298.298 0 010 .425L6.528 11.406a.303.303 0 01-.212.088z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconCheck.eb1c8e0f.svg";
export { MemoForwardRef as ReactComponent };